import generateFilterConfigs from "../../utils/FilterConfigGenerator";
import React, { useContext, useEffect, useState } from "react";
import FilterComponent from "../../components/complex/crud/FilterComponent";
import { Paginator } from "primereact/paginator";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { TabView, TabPanel } from "primereact/tabview";

import ChangeDateEditorDialog from "./ChangeDateEditorDialog.js";
import ChangeStatusEditorDialog from "./ChangeStatusEditorDialog.js";
import ChangePembayaranEditorDialog from "./HistoriPembayaranEditorDialog.js";
import HistoriPembayaranDialog from "./HistoriPembayaranDialog.js";
import { useDispatch } from "react-redux";
import UiContext from "../../store/ui-context";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { DataTable } from "primereact/datatable";
import {
  genRetribusiTemplateBodyAction,
  genTemplateBodyText,
} from "../../components/utils/TableTemplateBodyGenerator";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import createFilterText from "../../utils/CreateFilterText";

const title = "Retribusi Kendaraan";
let fetchOrderBy = "tanggal_stnk";
const fetchOrderMethod = "ASC";
const apiUrl = "kendaraan";

/**
 * Generate Filter Component
 *
 * available options for type:
 * text_plain
 * number_plain
 * date
 */
const filterConfigs = generateFilterConfigs([
  {
    name: "Nomor Polisi",
    field: "nomor_polisi",
    type: "text_plain",
    filter: true,
  },
]);

const KendaraanRetribusiPage = (props, { className }) => {
  const uiContext = useContext(UiContext);
  const dispatch = useDispatch();
  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const { loading: editorLoading, requestPost: editorRequestPost } =
    useAPIRequest();

  const [firstLoad, setFirstLoad] = useState(false);
  const [paging, setPaging] = useState({
    page: 1,
    take: 10,
    filter: "",
    total: 0,
  });
  const [listData, setListData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);

  const [changeDateEditorDialogShowed, setChangeDateEditorDialogShowed] =
    useState(false);
  const [changeStatusEditorDialogShowed, setChangeStatusEditorDialogShowed] =
    useState(false);
  const [historiPembayaranDialogShowed, setHistoriPembayaranDialogShowed] =
    useState(false);

  const [activeIndex, setActiveIndex] = useState(0);

  const [jenisTanggal, setJenisTanggal] = useState("tanggal_stnk");
  const [jenisRetribusi, setJenisRetribusi] = useState("status_stnk");
  const [pembayaranType, setPembayaranType] = useState("stnk");

  // useEffect section

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
    fetchListData({ page: 1, take: 10, filter: "" });
  }, []);

  // API call section

  const fetchListData = async ({ page, take, filter }) => {
    if (loading) return;

    const _filter = filter;

    return requestGet({
      fullUrl: `/api/masterdata/${apiUrl}/data`,
      params: {
        page: page,
        take: take,
        filter: _filter,
        order: fetchOrderBy,
        order_method: fetchOrderMethod,
        with_kendaraan_jenis: 1,
        with_kendaraan_grup: 1,
        with_kendaraan_pemakaian: 1,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: _filter,
        });
        setListData(data);
        if (!firstLoad) {
          setFirstLoad(true);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const fetchData = async ({ id }) => {
    if (loading) return;
    return requestGetOne({
      fullUrl: `/api/masterdata/${apiUrl}/one/${id}`,
      onSuccess: ({ message, data }) => {},
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const saveData = async ({ data }) => {
    if (loading) return;
    const valid = validateData();

    if (valid) {
      const body = convertSaveData(data);

      return editorRequestPost({
        fullUrl: `/api/masterdata/${apiUrl}/save`,
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
        onSuccess: ({ data: responseData, message }) => {
          uiContext.showSuccessMsg("Success", message);
        },
      });
    }
    return null;
  };

  // methods & functions section

  //   const resetEditorError = () => {
  //     setEditorError({});
  //   };

  const validateData = () => {
    let valid = true;

    return valid;
  };

  const convertSaveData = (data) => {
    return data;
  };

  // handle UI events section

  const handleOnReload = async () => {
    setPaging({ ...paging, filter: "" });
    fetchListData({
      page: paging.page,
      take: paging.take,
      filter: "",
    });
  };

  const handleOnFilter = (filterMap) => {
    const filterString = createFilterText(filterMap);
    setPaging({ ...paging, filter: filterString });
    fetchListData({
      page: paging.page,
      take: paging.take,
      filter: filterString,
    });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnChangeDate = async (row) => {
    const newData = await fetchData({ id: row.id });
    if (newData) {
      setSelectedData({ ...newData });
      setChangeDateEditorDialogShowed(true);
    }
  };
  const handleOnChangeStatus = async (row) => {
    const newData = await fetchData({ id: row.id });
    if (newData) {
      setSelectedData({ ...newData });
      setChangeStatusEditorDialogShowed(true);
    }
  };
  const handleOnHistoriPembayaran = async (row) => {
    const newData = await fetchData({ id: row.id });
    if (newData) {
      setSelectedData({ ...newData });
      setHistoriPembayaranDialogShowed(true);
    }
    // // const newData = await fetchData({ id: row.id });
    // // if (newData) {
    // // setChangePembayaranEditorData({ ...newData });
    // setKendaraanId(row.id);
    // setTahun(row.tahun);
    // setNopol(row.nomor_polisi);
    // setJenis(row.jenis_mobil);
    // setMerek(row.merek);
    // setHistoriPembayaranDialogShowed(true);
    // // }
  };

  const handleConfirmChangeDateEditor = async (data) => {
    const newData = await saveData({ data });
    if (newData) {
      const index = listData.findIndex((el) => el.id === newData.id);
      const newListData = [...listData];
      newListData.splice(index, 1, newData);
      setListData(newListData);
      setChangeDateEditorDialogShowed(false);
    }
  };

  const handleConfirmChangeStatusEditor = async (data) => {
    const newData = await saveData({ data });
    if (newData) {
      const index = listData.findIndex((el) => el.id === newData.id);
      const newListData = [...listData];
      newListData.splice(index, 1, newData);
      setListData(newListData);
      setChangeStatusEditorDialogShowed(false);
    }
  };

  const handleTabChange = (index) => {
    setActiveIndex(index);
    switch (index) {
      case 0:
        setJenisTanggal("tanggal_stnk");
        setJenisRetribusi("status_stnk");
        setPembayaranType("stnk");
        fetchOrderBy = "tanggal_stnk";
        break;
      case 1:
        setJenisTanggal("tanggal_pajak");
        setJenisRetribusi("status_pajak");
        setPembayaranType("pajak");
        fetchOrderBy = "tanggal_pajak";
        break;
      case 2:
        setJenisTanggal("tanggal_speksi");
        setJenisRetribusi("status_speksi");
        setPembayaranType("speksi");
        fetchOrderBy = "tanggal_speksi";
        break;
    }
  };

  // UI section

  /**
   * Generate Table Column
   *
   * various function to generate
   * genTemplateBodyAction({ row, onEdit, onDelete })
   * genTemplateBodyText({ row, field, defaultEmpty })
   * genTemplateBodyNumber({ row, field, defaultEmpty, maxFraction, minFraction })
   * genTemplateBodyDate({ row, field, format })
   * genTemplateBodyImage({ row, field })
   */
  const actionBodyTemplate = (row) =>
    genRetribusiTemplateBodyAction({
      row,
      onChangeDate: (row) => handleOnChangeDate(row),
      onChangeStatus: (row) => handleOnChangeStatus(row),
      onPayment: (row) => handleOnHistoriPembayaran(row),
    });

  const nomorPolisiBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "nomor_polisi" });
  const kendaraanJenisBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "data_kendaraan_jenis.nama" });
  const merekBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "merek" });
  const tglBerlakuBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: jenisTanggal });
  const jatuhTempoBodyTemplate = (row) => {
    if (row[jenisTanggal]) {
      // Convert both dates to milliseconds
      const date1Ms = new Date(row[jenisTanggal]).getTime();
      const date2Ms = new Date().getTime();
      // Calculate the difference in milliseconds
      const differenceMs = Math.abs(date1Ms - date2Ms);
      // Convert back to days and return
      return (
        new Date(row[jenisTanggal]).toLocaleDateString() +
        " (" +
        Math.ceil(differenceMs / (1000 * 60 * 60 * 24)) +
        " hari)"
      );
    }
  };
  const actionStatusBodyTemplate = (row) => {
    let status_name = "";
    switch (row[jenisRetribusi]) {
      case 0:
        status_name = "Pending";
        break;
      case 1:
        status_name = "Selesai";
        break;
      case 2:
        status_name = "Diproses";
        break;
      case 3:
        status_name = "Menunggu surat";
        break;
      case 4:
        status_name = "Menunggu pelat";
        break;
    }
    return status_name;
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ChangeDateEditorDialog
        jenis_tanggal={jenisTanggal}
        data={selectedData}
        setData={setSelectedData}
        loading={editorLoading}
        error={{}}
        setError={() => {}}
        visible={changeDateEditorDialogShowed}
        onHide={() => setChangeDateEditorDialogShowed(false)}
        onConfirm={handleConfirmChangeDateEditor}
      />
      <ChangeStatusEditorDialog
        jenis_retribusi={jenisRetribusi}
        data={selectedData}
        setData={setSelectedData}
        loading={editorLoading}
        error={{}}
        setError={() => {}}
        visible={changeStatusEditorDialogShowed}
        onHide={() => setChangeStatusEditorDialogShowed(false)}
        onConfirm={handleConfirmChangeStatusEditor}
      />
      <HistoriPembayaranDialog
        pembayaranType={pembayaranType}
        data={selectedData}
        setData={setSelectedData}
        loading={editorLoading}
        error={{}}
        setError={() => {}}
        visible={historiPembayaranDialogShowed}
        onHide={() => setHistoriPembayaranDialogShowed(false)}
        onConfirm={{}}
      />

      <TabView
        className={`w-100`}
        activeIndex={activeIndex}
        onTabChange={(e) => handleTabChange(e.index)}
      >
        <TabPanel className={`col-start-start gap-4`} header="STNK">
          <ConfirmDialog />

          <div className="elevated-card-tight-vertical w-100">
            <FilterComponent
              onFilter={handleOnFilter}
              configs={filterConfigs}
            />
          </div>

          <div className="elevated-card col-center-center w-100 gap-3">
            <div className={`row-between-center gap-2 w-100`}>
              <div className="row-start-center gap-2"></div>
              <div className="row-start-center">
                <Button
                  rounded
                  outlined
                  icon="pi pi-refresh"
                  onClick={handleOnReload}
                  style={{ width: "40px", height: "40px" }}
                />
              </div>
            </div>

            <div className={`row-center-center gap-2 w-100`}>
              <DataTable
                dataKey="id"
                className="w-100"
                loading={loading}
                showGridlines
                stripedRows
                editMode="cell"
                value={listData}
                selection={selectedData}
                onSelectionChange={(e) => setSelectedData(e.value)}
              >
                <Column
                  header="Action"
                  alignHeader={"center"}
                  headerClassName="w-[9rem]"
                  body={actionBodyTemplate}
                />

                <Column header="Nomor Polisi" body={nomorPolisiBodyTemplate} />
                <Column header="Jenis" body={kendaraanJenisBodyTemplate} />
                <Column header="Merek" body={merekBodyTemplate} />
                <Column header="Tgl Berlaku" body={tglBerlakuBodyTemplate} />
                <Column header="Jatuh Tempo" body={jatuhTempoBodyTemplate} />
                <Column
                  header="Status"
                  headerClassName="w-[20rem]"
                  body={actionStatusBodyTemplate}
                />
              </DataTable>
            </div>

            <Paginator
              first={parseInt(paging.take) * (paging.page - 1)}
              rows={parseInt(paging.take)}
              totalRecords={parseInt(paging.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              onPageChange={handleOnPage}
            />
          </div>
        </TabPanel>
        <TabPanel className={`col-start-start gap-4`} header="Pajak">
          <ConfirmDialog />

          <div className="elevated-card-tight-vertical w-100">
            <FilterComponent
              onFilter={handleOnFilter}
              configs={filterConfigs}
            />
          </div>

          <div className="elevated-card col-center-center w-100 gap-3">
            <div className={`row-between-center gap-2 w-100`}>
              <div className="row-start-center gap-2"></div>
              <div className="row-start-center">
                <Button
                  rounded
                  outlined
                  icon="pi pi-refresh"
                  onClick={handleOnReload}
                  style={{ width: "40px", height: "40px" }}
                />
              </div>
            </div>

            <div className={`row-center-center gap-2 w-100`}>
              <DataTable
                dataKey="id"
                className="w-100"
                loading={loading}
                showGridlines
                stripedRows
                editMode="cell"
                value={listData}
                selection={selectedData}
                onSelectionChange={(e) => setSelectedData(e.value)}
              >
                <Column
                  header="Action"
                  alignHeader={"center"}
                  headerClassName="w-[9rem]"
                  body={actionBodyTemplate}
                />

                <Column header="Nomor Polisi" body={nomorPolisiBodyTemplate} />
                <Column header="Jenis" body={kendaraanJenisBodyTemplate} />
                <Column header="Merek" body={merekBodyTemplate} />
                <Column header="Tgl Berlaku" body={tglBerlakuBodyTemplate} />
                <Column header="Jatuh Tempo" body={jatuhTempoBodyTemplate} />
                <Column
                  header="Status"
                  headerClassName="w-[20rem]"
                  body={actionStatusBodyTemplate}
                />
              </DataTable>
            </div>

            <Paginator
              first={parseInt(paging.take) * (paging.page - 1)}
              rows={parseInt(paging.take)}
              totalRecords={parseInt(paging.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              onPageChange={handleOnPage}
            />
          </div>
        </TabPanel>
        <TabPanel className={`col-start-start gap-4`} header="Speksi">
          <ConfirmDialog />

          <div className="elevated-card-tight-vertical w-100">
            <FilterComponent
              onFilter={handleOnFilter}
              configs={filterConfigs}
            />
          </div>

          <div className="elevated-card col-center-center w-100 gap-3">
            <div className={`row-between-center gap-2 w-100`}>
              <div className="row-start-center gap-2"></div>
              <div className="row-start-center">
                <Button
                  rounded
                  outlined
                  icon="pi pi-refresh"
                  onClick={handleOnReload}
                  style={{ width: "40px", height: "40px" }}
                />
              </div>
            </div>

            <div className={`row-center-center gap-2 w-100`}>
              <DataTable
                dataKey="id"
                className="w-100"
                loading={loading}
                showGridlines
                stripedRows
                editMode="cell"
                value={listData}
                selection={selectedData}
                onSelectionChange={(e) => setSelectedData(e.value)}
              >
                <Column
                  header="Action"
                  alignHeader={"center"}
                  headerClassName="w-[9rem]"
                  body={actionBodyTemplate}
                />

                <Column header="Nomor Polisi" body={nomorPolisiBodyTemplate} />
                <Column header="Jenis" body={kendaraanJenisBodyTemplate} />
                <Column header="Merek" body={merekBodyTemplate} />
                <Column header="Tgl Berlaku" body={tglBerlakuBodyTemplate} />
                <Column header="Jatuh Tempo" body={jatuhTempoBodyTemplate} />
                <Column
                  header="Status"
                  headerClassName="w-[20rem]"
                  body={actionStatusBodyTemplate}
                />
              </DataTable>
            </div>

            <Paginator
              first={parseInt(paging.take) * (paging.page - 1)}
              rows={parseInt(paging.take)}
              totalRecords={parseInt(paging.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              onPageChange={handleOnPage}
            />
          </div>
        </TabPanel>
      </TabView>
    </div>
  );
};

export default KendaraanRetribusiPage;
